module.exports = __webpack_public_path__ + "static/plantacje_mapa-a2f257e965d35b92f64a8849fc8e0a5b.png";